/* @ngInject */
const myCommandeEditForm = () => {
  return {
    restrict: 'E',
    scope: {
      myCommande: '=',
      myWagons: '=',
      enableTitle: '=?',
      enableBack: '=?',
    },
    template: require('./myCommandeEditForm.html'),

    /* @ngInject */
    controller: (
      $scope,
      $$commande
    ) => {
      $scope.wagonIds = []

      $scope.update = (_commande, _wagonIds) => {
        $$commande.ask.update(_commande, _wagonIds, true)
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myCommandeEditForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/commande/directives/forms/myCommandeEditForm.js